module.exports = __webpack_public_path__ + "static/media/battery-cable-replacement.9ed94ff1.svg";